export const breakpoints = {
    xxsmall: 375,
    xsmall: 425,
    small: 768,
    medium: 1024,
    large: 1200,
    xlarge: 1400,
    xxlarge: 1600,
};
